import React from 'react'
import PicCont from './PicCont'
import { AiOutlineClockCircle } from '@react-icons/all-files/ai/AiOutlineClockCircle'
import { GrMapLocation } from '@react-icons/all-files/gr/GrMapLocation';
import { FiTruck } from '@react-icons/all-files/fi/FiTruck';
import { GrLocation } from '@react-icons/all-files/gr/GrLocation';
import LinkWrap from './LinkWrap';
import AudioAction from './design-system/audio/AudioAction';
import BusinessInfoV2 from './design-system/marketing/BusinessInfoV2';
import { BUSINESS_HOURS_DISPLAY } from '../content/businessHours';


const BusinessInfo = ({orlando, sectionId, ui }) => {

    if (ui === 'v2') {
        return <BusinessInfoV2 orlando={orlando} sectionId={sectionId} />
    }

    return <section className=' businessInfo'>
        <h2 className='upperBold' >AV Rental Company in {orlando ? 'Orlando and Central Florida' :`Miami & FT Lauderdale`}</h2>
        <div className="row">
            <div className="infoCol">

                <div className="titleRow">
                    <div className='upper'>Our Location</div>
                    <GrLocation />
                </div>
                {orlando ? <>
                    {ui === 'v2'
                      ? <AudioAction mode='text' href='/orlando'>Orlando Branch</AudioAction>
                      : <LinkWrap href='/orlando'>Orlando Branch</LinkWrap>}
                                <p>8600 Commodity Cir #152<br/><br/>
                                Orlando, FL 32819</p>

                                 </>
                :
                <p>We are located at 20227 NE 15th Ct, Miami FL 33179, on I-95 and Ives Dairy.</p>
                }


                <div className="titleRow">
                    <div className='upper'>Delivery & Setup 24 / 7</div>
                    <FiTruck />
                </div>
                <p>We provide 24-hour, 7-day-a-week audiovisual production services. We also service last-minute requests.</p>



            </div>
            <div className="infoCol">


                <div className="titleRow">
                    <div className='upper'>Service Area</div>
                    <GrMapLocation />
                </div>
                {orlando ?
                 <p>Orlando, Tampa and the rest of Central Florida.</p>
            :
            <p>Miami, Fort Lauderdale, Boca Raton, Palm Beach, and the rest of South Florida.</p>
            }


                <div className="titleRow">
                    <div className='upper'>Business Hours</div>
                    <AiOutlineClockCircle />
                </div>

                <ul className='pSize bisHours'>
                    {BUSINESS_HOURS_DISPLAY.map(([day, hours]) => (
                        <li key={day}><span>{day}:</span><span>{hours}</span></li>
                    ))}
                </ul>

            </div>
            {orlando ?
              <iframe className='googleMap' title='Google Map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56130.27280788302!2d-81.431191!3d28.445134!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77fb418c8417d%3A0xe3ee1bf6f1075aa!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1731515480989!5m2!1sen!2sus" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            :
            <iframe className='googleMap' title='Google Map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85279.76786666439!2d-80.18819877200482!3d25.972544745070756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x641f16c240d54da2!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1656608031734!5m2!1sen!2sus" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            }


        </div>

        {/* <PicCont src={delivery} width={1500} height={1000} alt='Equipment Delivery' /> */}





    </section>

}

export default BusinessInfo
